import React from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import SendIcon from '@mui/icons-material/Send';

interface ChatInputProps {
  input: string;
  setInput: (input: string) => void;
  handleSend: () => void;
}

const ChatInput: React.FC<ChatInputProps> = ({ input, setInput, handleSend }) => {
  return (
    // <Box sx={{ p: 2, borderTop: '1px solid #ddd', bgcolor: 'white', borderRadius: 15 }}>
      <Box>
      <TextField
        fullWidth
        variant="filled"
        label="Ask a question"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Button onClick={handleSend} variant="contained" color="primary">
                <SendIcon />
              </Button>
            </InputAdornment>
          ),
        }}
        sx={{ borderRadius: 20 }}
      />
    </Box>
  );
};

export default ChatInput;